import React, { useState, useRef, useEffect } from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { getCustomerName, removeCustomerId, getCustomerId, getActiveAccounts, getCustomerBranchList, setBranchId, setCustomerId, setCustomerNames, setCustomerData, removeActiveAccounts } from "utility/HeaderConfig";
import { Link, useNavigate } from "react-router-dom";
import { useCartContext } from "context/UseCartContext";
import toast from "react-hot-toast";
import OpenModal from "components/OpenModal";
import { getAllAddress } from "api/AddressApi";

export default function TopbarMenus() {
  const history = useNavigate();
  const { login, dispatch } = useCartContext();
  const [open, setOpen] = useState(false);
  const [activeAccounts, setActiveAccountsState] = useState([]);
  const [selectedAccountId, setSelectedAccountId] = useState("");
  const [showAccountSwitch, setShowAccountSwitch] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (login) setActiveAccountsState(getActiveAccounts());
  }, [login]);

  useEffect(() => {
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const logout = () => {
    removeCustomerId();
    removeActiveAccounts();
    dispatch({ type: "LOGIN", payload: null });
    dispatch({ type: "ADD", payload: null });
    reactLocalStorage.remove("CartList");
    setOpen(false);
    toast.success("Signed out", {
      duration: 1500,
      position: "top-right",
      style: { background: "#1a1a1a", color: "#fff", borderRadius: "10px", fontSize: "13px" },
    });
    setTimeout(() => history("/"), 1200);
  };

  const handleChangeAccount = () => {
    const selected = switchableAccounts.find((a) => String(a.id) === String(selectedAccountId));
    if (!selected) {
      toast.error("Select an account to change");
      return;
    }
    const branchList = getCustomerBranchList();
    const matched = branchList.find((c) => String(c.id) === String(selected.id));
    if (!matched) {
      toast.error("Unable to switch account");
      return;
    }
    setBranchId(matched.branchId);
    setCustomerId(matched.id);
    setCustomerNames(matched.name);
    setCustomerData(JSON.stringify(matched));
    window.location.reload();
  };

  const openModal = (type) => {
    setOpen(false);
    setTimeout(() => dispatch({ type: "MODAL", payload: type }), 80);
  };

  const handleMyAddress = () => {
    setOpen(false);
    const customerId = getCustomerId();
    if (!customerId) { history("/AddAddress"); return; }
    getAllAddress({ customerEntity: customerId })
      .then((d) => {
        const hasAddress = d.response && d.response.length > 0;
        history(hasAddress ? "/ViewAddress" : "/AddAddress");
      })
      .catch(() => history("/AddAddress"));
  };

  const switchableAccounts = activeAccounts.filter(
    (acc) => String(acc.id) !== String(getCustomerId())
  );

  return (
    <div className="ej-topbar-menus">

      <Link to="/Offers" className="ej-topnav-link">Offers</Link>

      <div className="ej-acct-wrap" ref={wrapRef}>
        <button
          className="ej-acct-btn"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          aria-haspopup="true"
        >
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
            <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
          <span className="ej-acct-label">
            {login ? (getCustomerName()?.split(" ")[0] || "Account") : "Account"}
          </span>
          <svg
            width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
            style={{ transform: open ? "rotate(180deg)" : "none", transition: "transform 0.2s" }}
          >
            <polyline points="6 9 12 15 18 9"/>
          </svg>
        </button>

        <div className={`ej-acct-panel${open ? " ej-acct-panel--visible" : " ej-acct-panel--hidden"}`}>
          {login ? (
            <>
              <div className="ej-acct-name">{getCustomerName()}</div>
              <div className="ej-acct-divider" />
              {[
                { label: "My Wishlist", to: "/WishList" },
                { label: "My Purchase", to: "/MyPurchase" },
                { label: "My Address", action: handleMyAddress },
                { label: "Scheme Join", to: "/SchemeList" },
                { label: "Scheme Payment", to: "/MyScheme" },
              ].map((item, i) =>
                item.to ? (
                  <Link key={i} to={item.to} className="ej-acct-item" onClick={() => setOpen(false)}>
                    {item.label}
                  </Link>
                ) : (
                  <button key={i} onClick={item.action} className="ej-acct-item">
                    {item.label}
                  </button>
                )
              )}
              {switchableAccounts.length > 0 && (
                <>
                  <div className="ej-acct-divider" />
                  <button
                    type="button"
                    className="ej-acct-item ej-acct-switch-toggle"
                    onClick={() => setShowAccountSwitch((v) => !v)}
                    aria-expanded={showAccountSwitch}
                  >
                    <span>Change Account</span>
                    <svg
                      width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
                      style={{ transform: showAccountSwitch ? "rotate(180deg)" : "none", transition: "transform 0.2s", marginLeft: "auto" }}
                    >
                      <polyline points="6 9 12 15 18 9"/>
                    </svg>
                  </button>
                  {showAccountSwitch && (
                    <div className="ej-acct-switch">
                      <label className="ej-acct-switch-label">Change Account</label>
                      <select
                        className="ej-acct-switch-select"
                        value={selectedAccountId}
                        onChange={(e) => setSelectedAccountId(e.target.value)}
                      >
                        <option value="" disabled>Select account</option>
                        {switchableAccounts.map((acc, i) => (
                          <option key={i} value={acc.id}>{acc.customerName}</option>
                        ))}
                      </select>
                      <button
                        className="ej-acct-switch-btn"
                        disabled={!selectedAccountId}
                        onClick={handleChangeAccount}
                      >
                        Change
                      </button>
                    </div>
                  )}
                </>
              )}
              <div className="ej-acct-divider" />
              <button onClick={logout} className="ej-acct-item ej-acct-item--danger">
                Sign Out
              </button>
            </>
          ) : (
            <>
              <p className="ej-acct-greeting">Welcome to Eswar Gold India Pvt Ltd</p>
              <div className="ej-acct-divider" />
              <button className="ej-acct-signin" onClick={() => openModal("login")}>
                Sign In
              </button>
              <button className="ej-acct-item" onClick={() => openModal("register")}>
                Create Account
              </button>
            </>
          )}
        </div>
      </div>

      <OpenModal />
    </div>
  );
}